module.exports = __webpack_public_path__ + "static/img/10commitments_9.5e39c4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_9.jpg
// module id = qv+z
// module chunks = 0